module.exports = __webpack_public_path__ + "img/button-POP-MCD.3197e5cf.svg";